import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  text-align: center;
  color: #848c98;

  align-items: center;
  justify-content: center;
`;

export default Container;
